export default "__VITE_ASSET__CPffVkf8__"